module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAYAAAGtnFf2AAAAAXNSR0IArs4c6QAAAKpJREFUGBljPHPmDNdnYeF/DDsOnvnPAAIwBiOMwcLAyqgKkmFElgaxPexNwGIgNsOJE7f5wAwgwbjj0JmbDP8Z1EACQCU3mJgYGLrhsowMvWD2zkNnvoEwTAKFZtx//z7Hr0fvnv9n+C+AIgPkMDIwfmAT4ZAFW////3/GXYfO7gW63xGmECix383O2JmRkfE/0G6gDiDD3d7EiYmJqRjMZ2LIB/FB4iA+AFENOhO+o1bHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-login-2018/dropbutton.png
// module id = 704
// module chunks = 1